import AddOrdersProvider from './AddOrdersContext';
import AddOrders from './AddOrders';
import { MediaWorkOrder } from 'views/TicketDetails/TicketDetailsContext';

interface IProps {
    ticketNumber: string
    selectedRowIds: number[]
    onSelect: (workOrders: MediaWorkOrder[]) => void
}

let Index = (props: IProps) => {
    return (
        <AddOrdersProvider {...props}>
            <AddOrders />
        </AddOrdersProvider>
    )
}

export default Index;